export const BACKEND_URL = "localhost:8080";
export const PUBLIC_KEY_HEX = "82f8a77b5641783b5a5c7d8f89b9904f8145b62e24fac61d2a6d5320a7fc857a0dcb19c26403dc9121c88c01932a52cb0b08a0f3d2b98c6f5adffc36f2007b9fd677f5564883510634c890b8714a05eff4240e59ef1562339d71c1c13ae4c34f";
export const CERTIFICATE_MODE = "vrf" as const;
export const LOCATIONS: [[number, number], string][] = [];
